import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import { notification } from '../../component/hocs/notification';
import { Row, Col, Card, CardHeader, CardBody, Form, Input, Label, Button, } from 'reactstrap';

const AgricultureReport = () => {

    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [stateOpt, setStateOpt] = useState('');
    const [stateName, setStateName] = useState('');
    const [finYear, setFinYear] = useState('');
    const [seasons, setSeasons] = useState('');

    const getAgricultureReport = async (e) => {
        setTableData('');
        e.preventDefault();
        try {
            setLoading(true);

            let postData = [{
                org_id: sessionStorage.getItem('org_id'),
                user_id: sessionStorage.getItem('user_id'),
                "season_id": seasons, //2
                "fy": finYear,
                "state_id": stateName
            }]

            const response = await axios.post(mainurl + "Activity/rpt_outcome_ag", postData);

            if (response.data) {
                setTableData(response.data);
            } else {
                notification({ message: "No Data Found", type: "warn" })();
            }

        } catch (error) {
            notification({ message: "Server Error", type: "error" })();
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        get_state_list();
    }, []);

    const get_state_list = () => {
        let postData = [{ user_id: sessionStorage.getItem('user_id') }];

        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list2',
            data: postData,
            headers: { 'Content-Type': 'application/json' }
        })
            .then(function (response) {
                console.log("response", response.data);
                let list = response.data.map((row) => {
                    return <option value={row.state_code}>{row.state_name}</option>
                });
                setStateOpt(list);
            })
            .catch(() => {
                notification({
                    message: "State not found!",
                    type: 'error'
                })();
            });
    }

    const columns = [
        { name: "FY", selector: row => row.fy, sortable: true },
        { name: "Season", selector: row => row.season_desc },
        { name: "Crop", selector: row => row.crop_name },
        { name: "Sowing Area", selector: row => row.sowing_area },
        { name: "Seed Supported", selector: row => row.seed_supported },
        { name: "Harvesting", selector: row => row.harvesting },
        { name: "Trychodarma", selector: row => row.trychodarma },
        { name: "Agniastra", selector: row => row.agniastra },
        { name: "Neemastra", selector: row => row.neemastra },
        { name: "Income", selector: row => row.income },
        { name: "Consumption", selector: row => row.consumption },
    ];

    return (
        <>
            <Header />
            <Page title="Agriculture Report" breadcrumbs='Home / Agriculture Report'>
                <Row className='p-3'>
                    <Col xs={12}>
                        <Card className='mb-3' color="primary" outline>
                            <CardBody>
                                <Form onSubmit={getAgricultureReport}>
                                    <Row>
                                        <Col md={2} className="mb-2">
                                            <Label for="month">State</Label>
                                            <Input
                                                type="select"
                                                bsSize="sm"
                                                value={stateName}
                                                onChange={(e) => setStateName(e.target.value)}
                                                required
                                            >
                                                <option value="">--Select State--</option>
                                                {stateOpt}

                                            </Input>
                                        </Col>
                                        <Col md={2} className="mb-2">
                                            <Label for="finYear">Financial Year</Label>
                                            <Input
                                                type="select"
                                                bsSize="sm"
                                                value={finYear}
                                                onChange={(e) => setFinYear(e.target.value)}
                                                required
                                            >
                                                <option value="">--Select Financial Year--</option>
                                                <option value="2025">2025</option>
                                                <option value="2026">2026</option>
                                                <option value="2027">2027</option>
                                                <option value="2028">2028</option>
                                                <option value="2029">2029</option>
                                            </Input>
                                        </Col>
                                        <Col md={2} className="mb-2">
                                            <Label for="Seasons">Season</Label>
                                            <Input
                                                type="select"
                                                bsSize="sm"
                                                value={seasons}
                                                onChange={(e) => setSeasons(e.target.value)}
                                                required
                                            >
                                                <option value="">--Select Seasons--</option>
                                                <option value="1">Summer</option>
                                                <option value="2">Rainy</option>
                                                <option value="3">Winter</option>
                                            </Input>
                                        </Col>
                                        <Col md={2} className="mb-2">
                                            <Button className='text-white mt-4' color='primary' size="sm" block> Search </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                        <Card className='' color="primary" outline>
                            <CardHeader>Agriculture Report <small className='text-muted'> </small></CardHeader>
                            <CardBody>

                                <DataTable
                                    columns={columns}
                                    data={tableData}
                                    progressPending={loading}
                                    pagination
                                    highlightOnHover
                                    responsive
                                    customStyles={custTableStyles}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>    

            </Page>

            <Footer />
        </>
    );
};

export default AgricultureReport;
